import React from "react";
import { Link } from "react-router-dom";

export default function Confidentialite() {
  return (
    <main className="min-h-screen bg-[#080808] text-white">
      <section className="dmi-container py-20 lg:py-28">
        <div className="max-w-4xl mx-auto">

          {/* En-tête */}
          <div className="mb-14">
            <p className="text-[#C9A227] uppercase tracking-[0.3em] text-xs mb-4">
              Protection de vos données
            </p>

            <h1 className="text-4xl md:text-5xl font-semibold">
              Politique de confidentialité
            </h1>

            <p className="mt-6 text-white/60 leading-7 max-w-3xl">
              DALO MINISTRIES INTERNATIONAL accorde une importance particulière
              à la protection de votre vie privée et de vos données à caractère
              personnel.
            </p>
          </div>

          <div className="space-y-12 text-white/70 leading-7">

            {/* 1 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                1. Responsable du traitement
              </h2>

              <div className="space-y-3">
                <p>
                  Le responsable du traitement des données collectées sur le
                  présent site est :
                </p>

                <p>
                  <strong className="text-white">
                    DALO MINISTRIES INTERNATIONAL
                  </strong>
                  <br />
                  Association régie par la loi du 1er juillet 1901
                  <br />
                  RNA : W912009909
                  <br />
                  56 rue Henri Matisse
                  <br />
                  91100 Corbeil-Essonnes, France
                </p>

                <p>
                  Pour toute question relative à vos données personnelles,
                  vous pouvez nous contacter à :
                  {" "}
                  <a
                    href="mailto:contact@rolanddalo.com"
                    className="text-[#C9A227] hover:underline"
                  >
                    contact@rolanddalo.com
                  </a>
                </p>
              </div>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                2. Données que nous pouvons collecter
              </h2>

              <p className="mb-4">
                Selon les services que vous utilisez sur le site, DALO
                MINISTRIES INTERNATIONAL peut être amenée à collecter les
                informations que vous nous communiquez directement.
              </p>

              <div className="space-y-6">

                <div>
                  <h3 className="text-white font-medium mb-2">
                    Formulaire de contact
                  </h3>

                  <p>
                    Nom, adresse électronique, objet de la demande et contenu
                    du message.
                  </p>
                </div>

                <div>
                  <h3 className="text-white font-medium mb-2">
                    Demande de prière
                  </h3>

                  <p>
                    Nom, adresse électronique, pays et contenu de la demande
                    de prière.
                  </p>
                </div>

                <div>
                  <h3 className="text-white font-medium mb-2">
                    Demande pour devenir membre
                  </h3>

                  <p>
                    Prénom, nom, adresse électronique, ville, informations
                    relatives au parcours spirituel, ancienneté dans la foi,
                    motivations pour rejoindre DALO MINISTRIES INTERNATIONAL
                    et engagement aux valeurs et à la vision de l'association.
                  </p>
                </div>

                <div>
                  <h3 className="text-white font-medium mb-2">
                    Inscription aux messages et actualités
                  </h3>

                  <p>
                    Adresse électronique communiquée volontairement lors de
                    l'inscription.
                  </p>
                </div>

              </div>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                3. Finalités des traitements
              </h2>

              <p className="mb-4">
                Les données collectées peuvent être utilisées afin de :
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>répondre aux demandes adressées via le formulaire de contact ;</li>

                <li>
                  recevoir, transmettre aux personnes habilitées et traiter
                  les demandes de prière ;
                </li>

                <li>
                  examiner et gérer les demandes pour devenir membre de
                  DALO MINISTRIES INTERNATIONAL ;
                </li>

                <li>
                  communiquer avec les personnes ayant effectué une demande ;
                </li>

                <li>
                  envoyer les messages, informations et actualités de
                  DALO MINISTRIES INTERNATIONAL aux personnes inscrites ;
                </li>

                <li>
                  assurer le fonctionnement, la sécurité et l'amélioration du
                  site.
                </li>
              </ul>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                4. Données sensibles
              </h2>

              <div className="space-y-4">
                <p>
                  Certains services proposés sur le site peuvent conduire au
                  traitement d'informations révélant notamment les convictions
                  religieuses des personnes concernées.
                </p>

                <p>
                  C'est notamment le cas des informations communiquées dans le
                  cadre d'une demande pour devenir membre et, selon son
                  contenu, d'une demande de prière.
                </p>

                <p>
                  Une demande de prière étant rédigée librement, nous vous
                  recommandons de ne communiquer que les informations
                  strictement nécessaires à votre demande et d'éviter de
                  transmettre inutilement des informations particulièrement
                  sensibles concernant vous-même ou une autre personne.
                </p>

                <p>
                  Ces informations font l'objet d'une attention particulière
                  et leur accès est limité aux personnes habilitées à les
                  traiter dans le cadre de leurs fonctions au sein de
                  DALO MINISTRIES INTERNATIONAL.
                </p>
              </div>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                5. Base juridique des traitements
              </h2>

              <div className="space-y-4">
                <p>
                  Les traitements réalisés par DALO MINISTRIES INTERNATIONAL
                  reposent, selon leur nature, sur votre demande, votre
                  consentement lorsque celui-ci est requis, l'intérêt légitime
                  de l'association à répondre aux personnes qui la contactent
                  et à assurer le fonctionnement de ses activités, ainsi que
                  sur les dispositions applicables aux activités légitimes
                  d'une association à finalité religieuse.
                </p>

                <p>
                  Lorsqu'un traitement nécessite votre consentement, celui-ci
                  peut être retiré dans les conditions prévues par la
                  réglementation applicable.
                </p>
              </div>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                6. Destinataires des données
              </h2>

              <div className="space-y-4">
                <p>
                  Les données personnelles collectées sont destinées aux
                  personnes habilitées au sein de DALO MINISTRIES INTERNATIONAL
                  qui ont besoin d'y accéder pour traiter la demande
                  correspondante.
                </p>

                <p>
                  En particulier, les demandes de prière et les demandes pour
                  devenir membre ne doivent être accessibles qu'aux personnes
                  autorisées à assurer leur traitement.
                </p>

                <p>
                  Certaines données peuvent également être traitées par des
                  prestataires techniques intervenant pour le fonctionnement,
                  l'hébergement, la maintenance ou l'envoi de communications,
                  uniquement lorsque cela est nécessaire à la fourniture du
                  service concerné.
                </p>

                <p>
                  DALO MINISTRIES INTERNATIONAL ne vend pas vos données
                  personnelles.
                </p>
              </div>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                7. Durée de conservation
              </h2>

              <div className="space-y-4">
                <p>
                  Les données personnelles sont conservées uniquement pendant
                  la durée nécessaire à la réalisation de la finalité pour
                  laquelle elles ont été collectées, puis supprimées ou
                  archivées lorsque la réglementation applicable l'exige.
                </p>

                <p>
                  Les demandes de contact et de prière sont conservées pendant
                  le temps nécessaire à leur traitement et à leur suivi.
                </p>

                <p>
                  Les informations relatives aux demandes pour devenir membre
                  sont conservées pendant la durée nécessaire à l'examen de la
                  demande. Lorsque la personne devient membre, certaines
                  informations peuvent ensuite être conservées dans le cadre
                  de la gestion de la relation avec l'association.
                </p>

                <p>
                  Les adresses électroniques utilisées pour l'envoi des
                  messages et actualités sont conservées jusqu'à la
                  désinscription de la personne concernée ou jusqu'à ce que
                  leur conservation ne soit plus nécessaire.
                </p>
              </div>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                8. Sécurité des données
              </h2>

              <p>
                DALO MINISTRIES INTERNATIONAL met en œuvre des mesures
                techniques et organisationnelles appropriées afin de protéger
                les données personnelles contre l'accès non autorisé, la
                divulgation, l'altération, la perte ou la destruction
                accidentelle ou illicite.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                9. Vos droits
              </h2>

              <div className="space-y-4">
                <p>
                  Conformément à la réglementation applicable en matière de
                  protection des données personnelles, vous pouvez, selon les
                  circonstances, disposer notamment des droits suivants :
                </p>

                <ul className="list-disc pl-6 space-y-2">
                  <li>droit d'accès à vos données personnelles ;</li>
                  <li>droit de rectification des données inexactes ;</li>
                  <li>droit à l'effacement de vos données ;</li>
                  <li>droit à la limitation du traitement ;</li>
                  <li>droit d'opposition à certains traitements ;</li>
                  <li>droit à la portabilité lorsque celui-ci est applicable ;</li>
                  <li>
                    droit de retirer votre consentement à tout moment lorsque
                    le traitement repose sur celui-ci.
                  </li>
                </ul>

                <p>
                  Pour exercer vos droits, vous pouvez nous contacter à :
                  {" "}
                  <a
                    href="mailto:contact@rolanddalo.com"
                    className="text-[#C9A227] hover:underline"
                  >
                    contact@rolanddalo.com
                  </a>
                  .
                </p>

                <p>
                  Afin de protéger vos données, des informations
                  complémentaires permettant de vérifier votre identité
                  pourront être demandées lorsque cela est nécessaire.
                </p>
              </div>
            </section>

            {/* 10 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                10. Réclamation auprès de la CNIL
              </h2>

              <p>
                Si vous estimez, après nous avoir contactés, que vos droits
                relatifs à vos données personnelles ne sont pas respectés,
                vous pouvez introduire une réclamation auprès de la Commission
                nationale de l'informatique et des libertés (CNIL).
              </p>
            </section>

            {/* 11 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                11. Cookies et services tiers
              </h2>

              <div className="space-y-4">
                <p>
                  Le site peut utiliser des cookies ou d'autres technologies
                  nécessaires à son fonctionnement et peut intégrer des
                  services ou contenus provenant de tiers.
                </p>

                <p>
                  Lorsque l'utilisation d'un cookie ou d'un service tiers
                  nécessite le consentement de l'utilisateur, celui-ci doit
                  pouvoir accepter ou refuser son utilisation avant son dépôt
                  ou son activation, conformément à la réglementation
                  applicable.
                </p>
              </div>
            </section>

            {/* 12 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                12. Inscription aux messages et actualités
              </h2>

              <div className="space-y-4">
                <p>
                  Lorsque vous renseignez votre adresse électronique afin de
                  recevoir les messages et actualités de DALO MINISTRIES
                  INTERNATIONAL, celle-ci est utilisée pour vous adresser les
                  communications auxquelles vous avez choisi de vous inscrire.
                </p>

                <p>
                  Vous pouvez demander à ne plus recevoir ces communications à
                  tout moment, notamment en utilisant le moyen de
                  désinscription proposé dans les communications ou en nous
                  contactant à l'adresse indiquée dans la présente politique.
                </p>
              </div>
            </section>

            {/* 13 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                13. Transferts de données
              </h2>

              <p>
                Si certains prestataires techniques utilisés par DALO
                MINISTRIES INTERNATIONAL conduisent à un traitement ou à un
                transfert de données en dehors de l'Espace économique
                européen, les mesures et garanties requises par la
                réglementation applicable devront être mises en place.
              </p>
            </section>

            {/* 14 */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                14. Modification de la présente politique
              </h2>

              <p>
                La présente politique de confidentialité peut être modifiée
                afin de tenir compte de l'évolution du site, des services
                proposés ou de la réglementation applicable. La version
                publiée sur cette page est la version en vigueur.
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                15. Contact
              </h2>

              <p>
                Pour toute question concernant cette politique ou le traitement
                de vos données personnelles :
              </p>

              <div className="mt-4">
                <p className="text-white">
                  DALO MINISTRIES INTERNATIONAL
                </p>

                <p>
                  56 rue Henri Matisse
                  <br />
                  91100 Corbeil-Essonnes, France
                </p>

                <p className="mt-2">
                  <a
                    href="mailto:contact@rolanddalo.com"
                    className="text-[#C9A227] hover:underline"
                  >
                    contact@rolanddalo.com
                  </a>
                </p>
              </div>
            </section>

            {/* Liens */}
            <section className="pt-6 border-t border-white/10">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                <p className="text-sm text-white/40">
                  Dernière mise à jour : octobre 2026.
                </p>

                <Link
                  to="/mentions-legales"
                  className="text-sm text-[#C9A227] hover:underline"
                >
                  Consulter les mentions légales
                </Link>

              </div>
            </section>

          </div>
        </div>
      </section>
    </main>
  );
}